// extracted by mini-css-extract-plugin
export default {"list":"ActionTemp_list__HesYc","wrapper":"ActionTemp_wrapper__5Y7YH","title":"ActionTemp_title__ouhdl"};